import values from 'lodash/values';

import createSort from '../../../../shared/table/create-sort.js';

const defaultInitialState = {
	columns: {
		id: {
			index: 'id',
			title: 'Id',
			direction: 'desc'
		},
		date: {
			index: 'date',
			title: 'Date',
			direction: 'desc'
		},
		admin_id: {
			index: 'admin_id',
			title: 'Sender',
			direction: 'desc'
		},
		affiliate_id: {
			index: 'affiliate_id',
			title: 'Recipient',
			className: 'modify--border',
			direction: 'desc'
		},
		comment: {
			index: 'comment',
			title: 'Comment'
		},
		amount: {
			index: 'amount',
			title: 'Amount',
			className: 'amount',
			direction: 'desc'
		}
	},
	sortByColumn: {
		index: 'id',
		title: 'Id',
		direction: 'desc'
	}
};

const createTable = ({
	namespace,
	stateNodeName,
	configureSort
}) => {

	const sort = createSort(namespace, stateNodeName, {
		type: configureSort.type,
		resolverSortFn: configureSort.resolverSortFn
	});

	// action types
	const SHOW_MORE_ROWS = `${namespace}/table-show-more-rows`;

	// initState
	const initialState = {
		...defaultInitialState
	};

	// actions
	const actions = Object.assign({
		showMoreRows: () => ({
			type: SHOW_MORE_ROWS
		})
	}, sort.actions);

	// reducers
	const reducers = Object.assign({}, sort.reducers);

	// selectors
	const selectors = {
		getTable: state => {
			const { table, data } = state[namespace];
			const rows = data ? sort.order(data, table.sortByColumn) : [];

			return {
				headers: values(table.columns),
				rows,
				sortedColumn: table.sortByColumn,
				rowsNumber: table.rowsNumber,
				totalRows: rows.length
			};
		}
	};

	return {
		initialState,
		actions,
		reducers,
		selectors
	};
};

export default createTable;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-log/transfers/components/table/index.js